export class PinyinUtil {
  public static pinyin: any = require('pinyin');

  // æåé¦å­æ¯ï¼è¿åå¤§åå½¢å¼
  public static getCamelChars(str: string): string {
    if (!str) {
      return '';
    }
    let fullChars = this.pinyin(str, {
      style: this.pinyin.STYLE_FIRST_LETTER // è®¾ç½®æ¼é³é£æ ¼
    });
    return fullChars[0][0].substr(0, 1).toUpperCase();
  }

  /**
   * å¯¹æ°ç»è¿è¡æåº
   * @param data éè¦æåºçæ°ç»
   * @param attr éè¦æåºçå­æ®µ
   * @param isDesc æ¯å¦ååº
   */
  public static sortByPinyin(data: any[], attr: string, isDesc?: boolean) {
    // æ¯è¾çç³»æ°ï¼ç¨äºæ­£åº/ååº
    let ratio = isDesc ? -1 : 1;
    data.sort((a, b) => ratio * this.pinyin.compare(a[attr], b[attr]));
  }
}
